import { useI18nStore } from "@/stores/i18n"
import { useConfigStore } from "@/stores/config"
import { downloadAndUnzipAudioFiles } from "@/services/zipDownloader"
import { useHelpStore } from "@/components/af/Help/help.store"
import detectIncognito from "detectincognitojs"
import { storeToRefs } from "pinia"
import { UAParser } from "ua-parser-js"

import type { QuestionsOptions } from "@/types/s3"

export async function getAudio(options: QuestionsOptions) {
  const { urls } = useConfigStore()
  const { currentLocale } = useI18nStore()
  const { setIsReady } = useHelpStore()
  const { showPrivateSafariTooltip } = storeToRefs(useHelpStore())

  const browser = new UAParser().getResult()
  const result = await detectIncognito()
  if (
    result.browserName === "Safari" &&
    (result.isPrivate || Number(browser?.browser?.version) < 17)
  ) {
    showPrivateSafariTooltip.value = true
    return
  }
  // Construct the URL for the audio file
  const audioURL = `${urls.assets}/audio/${options.test === "swipe" ? "swipe_v2" : options.test}/${currentLocale.iso_code}.zip`

  try {
    await downloadAndUnzipAudioFiles(audioURL)
    setIsReady(true)
  } catch (err) {
    console.error("Error downloading audio files: ", err)
    throw err
  }
}
